var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-service-message"},[_vm._v(" No data available. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }